import { render } from "./icon-chevron-left copy.vue?vue&type=template&id=1ac84011"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__